import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";
import { AnnualTradingReportFilter } from "../types";

export const getAnnualProductReport = (
  user: User,
  filter: AnnualTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getannualtradingreport",
    params: {
      userid: user.userId,
      option: "P",
      year: filter.year,
    },
  });
};

export default getAnnualProductReport;
